// extracted by mini-css-extract-plugin
export default {"compactField":"customerTypeForm_compactField__Qcren"};